<template>
  <div v-if="isLoading" class="d-flex justify-content-center spinner-border text-primary spinner-position form"></div>
  <div v-if="isLoading" class="spinner"></div>
  <div class="custom-footer__profile" v-if="!isLoading">
      <div class="custom-profile" style="padding-bottom: 0px;">
        <div class="svg-custom">
          <router-link :to="isMember ? '/client/benefit' : '/account'">
            <img :src="(!imageErrorStatus && image_url) ? image_url : defaultAvatar" alt="User Avatar" @error="imageError" class="avatar" />
          </router-link>
        </div>
        <div class="profile-attribute">
          <div class="user-name">{{ fullName }}</div>
          <div class="span-name">
            <span>
              <div>
                <span class="text-10">{{ user.email }}</span>
              </div>
              <o-button
                :variant="'custom-switch'"
                v-if="menuvisibility?.includes('Switch')"
                @click="showModalSwitch"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  class="bi bi-toggle-on"
                  viewBox="0 0 24 16"
                >
                  <path
                    d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10H5zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
                  />
                  </svg>switch
              </o-button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <a v-if="isMember" class="policies" @click="showPrivacyPolicy">
        Privacy Policy & Terms Conditions
    </a>
    <div class="after-profile" v-if="!isLoading">
      <div class="after-profile-sett">
        <a href="" class="a-profile-custom">
            <div class="profile-div-inner">
                <span class="span-custom-collapse-2">
                    <router-link :to="isMember ? '/client/benefit' : '/account'" class="for-collapse span-custom-collapse-2 my-profile">
                        My Profile
                    </router-link>
                </span>
            </div>
        </a>
        <div class="profile-div-inner">
          <span class="span-custom-collapse-2">
            <button @click="logout" class="for-collapse span-custom-collapse-2" :disabled="isLoading">
                {{ isLoading ? 'Logging out...' : 'Log Out' }}
            </button>
          </span>
        </div>
      </div>
    </div>
</template>
<script>
import store from '@/store/'
import {mapState} from 'vuex'
import { OButton } from "@/components/OmnihControl";

export default {
  emits: ['showModalSwitch', 'showPrivacyPolicy'],
  props: {
    menuvisibility: Array,
  },
  components: {
    OButton,
  },
  data: function () {
    return {
    userProfile: '',
    menu: [
      {
        link_name: "Dashboard",
        link_spesific: "/",
      },
      {
        link_name: "Corporate",
        link_spesific: "/corporate",
      },
      {
        link_name: "System Log",
        link_spesific: "/systemlog",
      },
      {
        link_name: "API Log",
        link_spesific: "/logsapi",
      },
      {
        link_name: "Branch",
        link_spesific: "/branch",
      },
      {
        link_name: "Business Profile",
        link_spesific: "/business-profile",
      },
      {
        link_name: "User",
        link_spesific: "/user",
      },
      {
        link_name: "Levels",
        link_spesific: "/level",
      },
      {
        link_name: "User Roles",
        link_spesific: "/role",
      },
      {
        link_name: "Transaction Report",
        link_spesific: "/transaction-report",
      },
      {
        link_name: "Member",
        link_spesific: "/member",
      },
      {
        link_name: "Merchant",
        link_spesific: "/merchant",
      },
      {
        link_name: "Product",
        link_spesific: "/product",
      },
      {
        link_name: "Point Plan",
        link_spesific: "/point/plan",
      },
      {
        link_name: "Transaction",
        link_spesific: "/transaction",
      },
      {
        link_name: "Benefit",
        link_spesific: "/benefit",
      },
      {
        link_name: "Voucher",
        link_spesific: "/voucher",
      },
      {
        link_name: "Voucher Redeem",
        link_spesific: "/voucher/redeem",
      },
    ],
    collapse: false,
    menu_visibility: [],
    image_url: '',
    imageErrorStatus: false,
    isLoading: false,
    };
  },
  mounted () {
    this.isLoading = true;
    
    if (this.menuvisibility) {
      this.menu_visibility = this.menu.filter((v) =>
        this.menuvisibility.includes(v.link_name)
      );
    }

    this.fetchAvatar().finally(() => {
      this.isLoading = false;
    });
    
    this.userProfile = localStorage.getItem('profile_name') ?? "";
  },
  watch: {
    menuvisibility(newVal) {
      this.menu_visibility = this.menu.filter((v) =>
        newVal.includes(v.link_name)
      );
    },
    selectedBusinessProfile(newVal) {
      const businessProfiles = this.businessProfiles;

      if (businessProfiles !== undefined) {
        this.userProfile = "";
        
        if(newVal.corporate_id !== null) {
          this.userProfile = this.businessProfiles.corporate.find((corp) => corp.id == newVal.corporate_id).name;
        }
        if(newVal.branch_id !== null) {
          const corporate = this.businessProfiles.corporate.length > 1 ? this.businessProfiles.corporate.find((corp) => corp.id == newVal.corporate_id) : this.businessProfiles.corporate.at(0);
          this.userProfile = corporate.branch.find((branch) => branch.id == newVal.branch_id).name;
        }
        if(newVal.merchant_id !== null) {
          const corporate = this.businessProfiles.corporate.length > 1 ? this.businessProfiles.corporate.find((corp) => corp.id == newVal.corporate_id) : this.businessProfiles.corporate.at(0);
          const branch = corporate.branch.length > 1 ? corporate.branch.find((branch) => branch.id == newVal.branch_id) : corporate.branch.at(0);
          this.userProfile = branch.merchant.find((merchant) => merchant.id == newVal.merchant_id).name;
        }
        
        localStorage.setItem('profile_name', this.userProfile);
      }
    },
    '$store.state.Auth.userInfo.member.member_avatar': function(newVal) {
      if (newVal) {
        this.image_url = newVal;
        this.imageErrorStatus = false;
      }
    }
  },
  methods: {
    imageError(event) {
      if (event){
        this.imageErrorStatus = true;
      }
    },
    async fetchAvatar() {
      this.imageErrorStatus = false;
      this.image_url = '';
      const memberAvatarFromStore = this.$store.state.Auth.userInfo?.member?.member_avatar;
      if (memberAvatarFromStore) {
        this.image_url = memberAvatarFromStore;
        return;
      }
      if (localStorage.getItem('id')) {
        try {
          const resp = await this.$store.dispatch('User/getAvatar', localStorage.getItem('id'));
          this.image_url = resp.data.data;
        } catch (error) {
          console.error('Error fetching avatar:', error);
        }
      } else {
        console.error('User ID is undefined');
      }
    },
    showModalSwitch() {
      this.$emit("showModalSwitch");
    },
    logout: async function() {
      try {
        this.isLoading = true;
        
        const isMemberUser = this.isMember;
        const newAuthFlag = store.getters['FeatureFlag/getNewAuthModuleFlag'];

        await store.dispatch('Auth/logout');
        
        const message = {
          type: 'logout',
          data: 'logoutSucceded',
          res: null,
          token: null,
          email: null,
        };
        
        window.parent.postMessage(message, '*');
        
        if (newAuthFlag === 'ACTIVE') {
          if (isMemberUser) {
            this.$router.push('/member/login');
          } else {
            this.$router.push('/backoffice/login');
          }
        } else {
          this.$router.push({ name: "Login" });
        }
      } catch (err) {
        console.error('Logout error:', err);
        this.isLoading = false;
      }
    },
    myprofile: async function() {
      this.isLoading = true;
      try {
        await this.$router.push({
          name: "Account"
        });
      } finally {
        this.isLoading = false;
      }
    },
    showPrivacyPolicy: function() {
      this.$emit('showPrivacyPolicy');
    }
  },
  computed: {
    ...mapState({
      selectedBusinessProfile: state => state.Auth.selectedBusinessProfile,
      businessProfiles: state => state.Auth.businessProfiles,
      user: state => state.Auth.currUser,
    }),
    defaultAvatar() {
      const title = this.user?.title || this.$store.state.Auth.userInfo?.title || '';
      return title === 'Mr.'
        ? 'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/man.png'
        : 'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/woman.png';
    },
    fullName() {
      const title = this.user.title || '';
      const firstName = this.user.first_name || '';
      const lastName = this.user.last_name || '';
      const name = `${title} ${firstName} ${lastName}`.trim() || this.user.name || this.user.email || '';
      return name.length > 25 ? `${name.substring(0, 25)}..` : name;
    },
    getInitials() {
      const title = this.user.title || '';
      const firstName = this.user.first_name || '';
      const lastName = this.user.last_name || '';
      const name = `${title} ${firstName} ${lastName}`.trim() || this.user.name || this.user.email || '';
      if (!name) return '?';
      const words = name.split(' ').filter(Boolean);
      if (words.length >= 2) {
        return (words[0][0] + words[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },
    isMember() {
      // Fix untuk native: fallback ke localStorage jika user.level belum ter-load
      if (this.user && this.user.level) {
        return this.user.level === 'member';
      }
      // Fallback untuk native platform saat data belum ter-load dari store
      const level = localStorage.getItem('level');
      return level === 'member';
    }
  },
};
</script>

<style scoped>
.btn-custom-switch {
  padding: 0px;
  color: #fff;
}

.btn-custom-switch:focus {
  outline: none;
  border: none;
  box-shadow: none;
}

.btn-custom-switch:hover {
  color: #fff;
}

.for-collapse{
  background-color: transparent;
  color: white;
  cursor: pointer;
  border: none;
}

.button{
  margin-left: 20px;
}

a.my-profile{
  margin-left: 19px;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}

.member-avatar-placeholder {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-gradient, linear-gradient(135deg, #F93E3E 0%, #E02020 100%));
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  user-select: none;
}

.policies {
  cursor: pointer;
  font-size: 10px;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 53px;
  color: #fff;
  text-decoration: none;
}

.policies:hover {
  color: #ffc107;
}

.user-name {
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.3;
}

.after-profile {
  margin-top: 0;
  margin-bottom: 0;
}
</style>